import { render, staticRenderFns } from "./AiAssumedFieldsNote.vue?vue&type=template&id=bd7cc18a&scoped=true"
import script from "./AiAssumedFieldsNote.vue?vue&type=script&lang=js"
export * from "./AiAssumedFieldsNote.vue?vue&type=script&lang=js"
import style0 from "./AiAssumedFieldsNote.vue?vue&type=style&index=0&id=bd7cc18a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7cc18a",
  null
  
)

export default component.exports